import BetCreated from './BetCreated';

export default BetCreated;
